// A detached copy of gon.currentUser, for embedding in local answers, quests and
// modal params. The store's immer set() auto-freezes (deeply) whatever it is
// handed, so embedding the live gon object froze it, and every later in-place
// write to gon.currentUser (space_options, options, pinned_quest_id, ...) threw
// or was silently dropped. gon.currentUser comes from Rails as JSON, so a JSON
// round-trip copies it faithfully and shares nothing with gon.
export function currentUserSnapshot() {
    const user = window.gon?.currentUser
    return user ? JSON.parse(JSON.stringify(user)) : user
}
